// tslint:disable: max-line-length
import { checkStatus, parseJSON } from './utils';

// TODO: Set this up to the proper T-Navigator auth
const generateHeaders = (locale, Authorization) => ({
  Accept: 'application/vnd.intrepid+json; version=2',
  'Accept-Language': locale,
  'Content-Type': 'application/json',
  Authorization
});

export const getCountries = (locale, auth) =>
  fetch(
    `${window.config.REACT_APP_BASE_URL}/api/travelnavigator/country?destination=true`,
    {
      method: 'GET',
      headers: generateHeaders(locale, auth)
    }
  )
    .then(checkStatus)
    .then(parseJSON);



// WEBPACK FOOTER //
// ./src/api/countries.js